var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_176_13483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 17,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37305 0.971924H24.0002V25.0281H7.37305V0.971924Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_176_13483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47641 8.72276H9.11601V2.75192H19.7713C18.392 3.55876 17.2892 4.26191 16.1313 4.85813C15.3947 5.23617 15.1506 5.74706 15.1571 6.56146C15.1916 10.2533 15.1722 13.9483 15.1722 17.639V19.081H9.1657V14.4733H7.48289C7.48289 16.33 7.45589 18.1467 7.49369 19.9634C7.51097 20.6936 8.05751 20.8675 8.69261 20.8632C10.4186 20.8535 12.1457 20.8589 13.876 20.8589H15.1787C15.1787 21.8936 15.1484 22.8484 15.1851 23.7989C15.2251 24.9017 15.7619 25.2138 16.7081 24.676C18.9223 23.4209 21.1365 22.1636 23.3086 20.8362C23.6478 20.6299 23.9621 20.0617 23.9664 19.6578C24.0064 13.8144 23.9859 7.96992 23.9999 2.12654C23.9999 1.28837 23.6273 0.97406 22.8442 0.97406C18.1209 0.981621 13.3965 0.981621 8.67317 0.97838C8.0413 0.97838 7.49585 1.14148 7.48721 1.88459C7.45805 4.13446 7.47641 6.38324 7.47641 8.72276Z",
    fill: "#F70000"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_176_13483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 12,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.60809H11.5204V15.6268H0V7.60809Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_176_13483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74425 12.784C7.18403 12.784 8.48016 12.7948 9.77629 12.7796C10.8586 12.7688 11.4775 12.3119 11.3954 11.5505C11.2928 10.6 10.6274 10.3721 9.80005 10.3807C8.50176 10.3937 7.20347 10.3829 5.74641 10.3829C5.74641 9.73157 5.76585 9.13859 5.74209 8.54669C5.70645 7.67828 5.37917 7.46442 4.71599 7.93211C3.27296 8.95497 1.86234 10.0232 0.445238 11.0806C0.000233397 11.4122 -0.0105678 11.7784 0.445238 12.1164C1.8969 13.1879 3.34101 14.2713 4.80888 15.3157C5.4159 15.7478 5.71833 15.4259 5.73993 14.7627C5.75937 14.1589 5.74641 13.5519 5.74641 12.784H5.74425Z",
    fill: "#F70000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.48e2825f793d3927f6eab0bf8d78e3fd.svg";
export { ForwardRef as ReactComponent };